import { CanvasJSChart } from 'app/components/CanvasJs';
import { getCurrencySemSinalMonetario } from 'app/utils/monetarioUtil';
import React from 'react';
import { coresGraficoContasPagar } from './styles';

const GraficoQuantidadeContasPagar = ({ values }) => {
  const totalContas =
    (values.quantidadeAbertas || 0) + (values.quantidadeBaixadas || 0) + (values.quantidadeParciais || 0);

  const percentualAberto =
    totalContas > 0 && values?.quantidadeAbertas > 0
      ? getCurrencySemSinalMonetario((values.quantidadeAbertas * 100) / totalContas).replace(',', '.')
      : 0;

  const percentualBaixada =
    totalContas > 0 && values?.quantidadeBaixadas > 0
      ? getCurrencySemSinalMonetario((values.quantidadeBaixadas * 100) / totalContas).replace(',', '.')
      : 0;

  const percentualParcial =
    totalContas > 0 && values?.quantidadeParciais > 0
      ? getCurrencySemSinalMonetario((values.quantidadeParciais * 100) / totalContas).replace(',', '.')
      : 0;

  return (
    <CanvasJSChart
      options={{
        culture: 'pt-br',
        animationEnabled: true,
        axisY: {
          prefix: '%',
          labelFontSize: 11,
        },
        toolTip: {
          shared: true,
        },
        legend: {
          fontSize: 16,
          cursor: 'pointer',
          verticalAlign: 'bottom',
        },
        data: [
          {
            type: 'doughnut',
            showInLegend: true,
            toolTipContent: '{label} - {y}%',
            indexLabel: '{label} - {y}%',
            dataPoints: [
              {
                y: percentualAberto || 0,
                label: 'Abertas',
                prefix: '%',
                color: coresGraficoContasPagar.azul,
                legendText: 'Abertas',
              },
              {
                y: percentualBaixada || 0,
                label: 'Baixadas',
                prefix: '%',
                color: coresGraficoContasPagar.verde,
                legendText: 'Baixadas',
              },
              {
                y: percentualParcial || 0,
                label: 'Parciais',
                prefix: '%',
                color: coresGraficoContasPagar.laranja,
                legendText: 'Parciais',
              },
            ],
          },
        ],
      }}
    />
  );
};

export default GraficoQuantidadeContasPagar;
